export const MAX_ACTIVE_MISSIONS = 5;
